export default __webpack_public_path__ + "static/media/scanBorder.483beb83.png";